import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import { 
  IconButton,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Button, 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core';
import moment from 'moment'; 
import {TableEditBar } from 'components';
import useRouter from 'utils/useRouter'
import AuthFetch from 'utils/fetch';
import {useHistory} from 'react-router-dom'
import {urls} from 'utils/url'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { isClassExpression } from 'typescript';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  }
}));

const Results = props => {
  const { className, todo, ...rest } = props; 
  const classes = useStyles();
  const history = useHistory();
  const router = useRouter();
  
  const deleteTodo = (todoName) => {
    AuthFetch(urls.deleteTodo.path(todoName), todoName, urls.deleteTodo.method).then((rvData) => {
      if(rvData.Status.Code == "1") {
        history.go(`/admin/todo`);
      }
    });
  }

  

  return ( 
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader 
          title="事项列表"
        />
        <Divider />
        <CardContent className={classes.content}>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableCell>序号</TableCell>
                <TableCell>事项名称</TableCell>
                <TableCell>具体描述</TableCell>
                <TableCell>截至日期</TableCell>
                <TableCell>操作</TableCell>
               
              </TableHead>
              
              <TableBody>
                {todo.map((todoItem, idx) => (
                  <TableRow
                  key={todoItem.name}
                  >
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    <div className={classes.nameCell}>
                      {todoItem.name}
                    </div>
                  </TableCell>
                  <TableCell>{todoItem.desc}</TableCell>
                  <TableCell>{todoItem.expireAt}</TableCell>
                  <TableCell>
                    
                    <Button
                      aria-label="delete"
                      onClick = {() => {deleteTodo(todoItem.name)}}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>
    </div>
  )
};


export default Results;
